module.exports = __webpack_public_path__ + "img/none.d82480fa.png";